const seachParams = new URLSearchParams(window.location.search);
const checkoutURL = seachParams.get('checkout_url');
const loginError = seachParams.get('error');

(async function redirectUserIfLoggedIn() {
  function redirectUserToAccountPage() {
    window.location.href = window.routes.account_url;
  }

  function disableLoginFormsLoadingState() {
    const $loginForms = document.querySelector('#login_forms');
    const $loginFormsLoading = $loginForms.querySelector('.loading');
    const $loginFormsLoaded = $loginForms.querySelector('.loaded');
    $loginFormsLoaded.classList.remove('tw-hidden');
    $loginFormsLoading.classList.add('tw-hidden');
  }

  const [error, authStatus] = await Customer.getUserAuthStatus();

  if (error) {
    return;
  }

  const userIsLoggedIn = authStatus.isLoggedInBackend && authStatus.isLoggedInShopify;

  if (userIsLoggedIn) {
    redirectUserToAccountPage();
  } else {
    disableLoginFormsLoadingState();
  }
})();

(function initRecoverPasswordForm() {
  const $form = document.querySelector('#recover_customer_password');
  if (!$form) {
    return;
  }
  const $submitButton = $form.querySelector('button[type="submit"]');
  const $submitButtonLoadingIcon = $submitButton.querySelector('.loading');
  const $submitButtonText = $submitButton.querySelector('.text');

  $form.addEventListener('submit', () => {
    $submitButtonLoadingIcon.classList.remove('tw-hidden');
    $submitButtonText.classList.add('tw-hidden');
  });
})();

(function initSubmitLoginForm() {
  const $loginForm = document.querySelector('#customer_login');
  if (!$loginForm) {
    return;
  }

  const $returnToInput = $loginForm.querySelector('input[name="return_to"]');
  const $loginButton = $loginForm.querySelector('.login-button');
  const $loginButtonLoadingIcon = $loginButton.querySelector('.loading');
  const $loginButtonText = $loginButton.querySelector('.text');
  const $errorMessage = $loginForm.querySelector('.error');
  const $message =
    $loginForm.querySelector(`[data-error-code="${loginError}"]`) ||
    $loginForm.querySelector('[data-error-code="default"]');

  if (checkoutURL) {
    $returnToInput.value = checkoutURL;
  }

  if (loginError && loginError !== 'login_required') {
    $errorMessage.classList.remove('tw-hidden');
    $message.classList.remove('tw-hidden');
  }

  $loginForm.addEventListener('submit', async () => {
    $errorMessage.classList.add('tw-hidden');
    $loginButtonLoadingIcon.classList.remove('tw-hidden');
    $loginButtonText.classList.add('tw-hidden');
  });
})();

(function InitFacebookLogin() {
  const $facebookLoginButton = document.querySelector('#facebook-login');
  if (!$facebookLoginButton) {
    return;
  }
  const $loading = $facebookLoginButton.querySelector('.loading');
  const $loaded = $facebookLoginButton.querySelector('.loaded');
  const $waitingForLoginMessage = $facebookLoginButton.querySelector('.waiting-for-login');

  async function onLoginButtonClick() {
    $waitingForLoginMessage.classList.remove('tw-hidden');
    $loading.classList.remove('tw-hidden');
    $loaded.classList.add('tw-hidden');

    $facebookLoginButton.disabled = true;

    Customer.loginWithFacebook({
      checkoutURL,
    });
  }

  $facebookLoginButton.addEventListener('click', onLoginButtonClick);
})();
